import { render, staticRenderFns } from "./clientCDIStaff.vue?vue&type=template&id=c87c5f24&scoped=true&"
import script from "./clientCDIStaff.vue?vue&type=script&lang=js&"
export * from "./clientCDIStaff.vue?vue&type=script&lang=js&"
import style0 from "./clientCDIStaff.vue?vue&type=style&index=0&id=c87c5f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87c5f24",
  null
  
)

export default component.exports